export const Globals = {

    //LIVE
  //   Url:'https://api.compasserp.com/api/api/services/app/',
    //  TokenUrl:'https://api.compasserp.com/api/api/services/app/HrPersons/Login',


  //Local
 //Url:'http://localhost:21021/api/services/app/',
//TokenUrl:'http://localhost:21021/api/TokenAuth/Authenticate',

  //LIVE
   // Url:'http://20.216.18.218:2082/api/services/app/',
   //TokenUrl:'http://20.216.18.218:2082/api/TokenAuth/Authenticate',

  Url:'https://apierp.fujcharity.ae/api/services/app/',
 TokenUrl:'https://apierp.fujcharity.ae/api/TokenAuth/Authenticate',



    // TokenUrl:'http://localhost:21021/api/services/app/HrPersons/Login'


 

   
  //  Url:'http://compassegy.ddns.net:3024/api/services/app/',
  // TokenUrl:'http://compassegy.ddns.net:3024/api/TokenAuth/Authenticate'
     
    // Url:'http://compassegy.ddns.net:1124/erpapi/api/services/app/',
    // TokenUrl:'http://compassegy.ddns.net:1124/erpapi/api/TokenAuth/Authenticate'
    // Url:'http://localhost/erpapi/api/services/app/',
    // TokenUrl:'http://localhost/erpapi/api/TokenAuth/Authenticate'
    // Url:'http://10.100.90.36/erpapi/api/services/app/',
    // TokenUrl:'http://10.100.90.36/erpapi/api/TokenAuth/Authenticate'
    // Url:'http://172.16.1.24:5050/erpapi/api/services/app/',
    // TokenUrl:'http://172.16.1.24:5050/erpapi/api/TokenAuth/Authenticate'
   // Url:'https://erpcharity.uaq.ae/erpapi/api/services/app/',
    //TokenUrl:'https://erpcharity.uaq.ae/erpapi/api/TokenAuth/Authenticate'
}

export function callRtlStyle(){
    document.body.style.direction = "rtl";
    if(document.getElementById('ltr-doc')){
      let link = document.getElementById('ltr-doc');
      link.parentNode.removeChild(link);
    }

    if(!document.getElementById('rtl-doc')){
      let toastr = document.getElementById('toastr');
      let link  = document.createElement('link');
      link.id   = 'rtl-doc';
      link.rel  = 'stylesheet';
      link.href = './assets/bootstrap-rtl.min.css';
      toastr.before(link);
    }
}

export function removeRtlStyle(){
    document.body.style.direction = "ltr";
    if(document.getElementById('rtl-doc')){
      let link = document.getElementById('rtl-doc');
      link.parentNode.removeChild(link);
    }

    if(!document.getElementById('ltr-doc')){
      let toastr = document.getElementById('toastr');
      let link  = document.createElement('link');
      link.id   = 'ltr-doc';
      link.rel  = 'stylesheet';
      link.href = './assets/bootstrap.min.css';
      toastr.before(link);
    }

}


// export function GetTime(date:Date){
//     let offset = new Date().getTimezoneOffset();
//     if(offset<0){
//         return new Date(date.getTime() + (Math.abs(offset)) * 60000);
//     }else{
//         return new Date(date.getTime() - (Math.abs(offset)) * 60000);
//     }
// }

// export function StringToDate(string:string){
//     let offset = new Date(string).getTimezoneOffset();
//     if(offset>0){
//         return new Date(new Date(string).getTime() + (Math.abs(offset)) * 60000);
//     }else{
//         return new Date(new Date(string).getTime() - (Math.abs(offset)) * 60000);
//     }
// }
